import { Phone } from "lucide-react";
import { BUSINESS } from "@/data/business";

export const StickyCallButton = () => {
  return (
    <a
      href={`tel:${BUSINESS.phoneClean}`}
      data-testid="sticky-call-button"
      aria-label={`Call Tira Spa at ${BUSINESS.phone}`}
      className="fixed z-[60] bottom-5 right-5 sm:bottom-7 sm:right-7 flex items-center gap-2.5 bg-tira-accent text-tira-bg pl-4 pr-5 py-3.5 sm:py-4 rounded-full shadow-[0_12px_32px_-8px_rgba(217,119,87,0.5)] border border-tira-accentHover/40 hover:bg-tira-accentHover hover:scale-105 active:scale-95 transition-all duration-300"
    >
      <span className="relative flex items-center justify-center w-6 h-6">
        <span className="absolute inline-flex h-full w-full rounded-full bg-tira-bg/30 animate-ping" />
        <Phone className="relative w-4 h-4" strokeWidth={2} />
      </span>
      <span className="font-sans text-sm sm:text-[15px] font-semibold tracking-wide whitespace-nowrap">
        {BUSINESS.phoneDisplay}
      </span>
    </a>
  );
};
